import React from 'react'
import { Popover, Button, Input } from 'antd'
import { translateKey as t } from '../../../locales/translation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'

const InputGroup = Input.Group

const NumericalFilter = ({ column, handleFilter }) => {
  const handleOnChange = (value, type, index?) => {
    if (type === 'between') {
      const oldIndex = index === 0 ? 1 : 0
      const oldVal = column.filterValue && Array.isArray(column.filterValue.value) ? column.filterValue.value[oldIndex] : null

      // if both fields are empty, pass the value as null so the filter gets reset
      if (!oldVal && !value) {
        value = null
      } else {
        value = index === 0 ? [value, oldVal] : [oldVal, value]
      }
    }

    handleValueChange(column, { value, type })
  }

  const handleValueChange = (column, obj) => {
    column.filterValue = !obj.value ? '' : obj

    if (!column.filterOnSubmit) {
      column.finalFilterValue = !obj.value ? '' : obj
    }
  }

  const getValue = (type, index?) => {
    if (column.filterValue && column.filterValue.type === type) {
      if (type === 'between') {
        return column.filterValue.value[index]
      }

      return column.filterValue.value
    } else {
      return ''
    }
  }

  const content = (
    <div>
      {!column.filterOnSubmit && (
        <Input
          size='small'
          style={{ width: 150, display: 'block' }}
          onChange={(e) => handleOnChange(e.target.value, 'includes')}
          value={getValue('includes')}
          data-e2e='numerical-filter-includes'
          placeholder={t('lblIncludes', 'Includes')}
        />
      )}
      <Input
        size='small'
        addonBefore='>'
        style={{ width: 150, display: 'block', marginTop: 5 }}
        onChange={(e) => handleOnChange(e.target.value, 'greaterThan')}
        data-e2e='numerical-filter-greater-than'
        value={getValue('greaterThan')}
        placeholder={t('lblGreaterThan', 'Greater Than')}
      />

      <Input
        size='small'
        addonBefore='<'
        style={{ width: 150, display: 'block', marginTop: 5 }}
        onChange={(e) => handleOnChange(e.target.value, 'lessThan')}
        data-e2e='numerical-filter-less-than'
        value={getValue('lessThan')}
        placeholder={t('lblLessThan', 'Less than')}
      />
      <InputGroup compact={true} style={{ marginTop: 5 }}>
        <Input
          size='small'
          style={{ width: 75 }}
          placeholder={t('lblMin', 'Min')}
          onChange={(e) => handleOnChange(e.target.value, 'between', 0)}
          data-e2e='numerical-filter-min'
          value={getValue('between', 0)}
        />
        <Input
          size='small'
          style={{ width: 75 }}
          placeholder={t('lblMax', 'Max')}
          data-e2e='numerical-filter-max'
          onChange={(e) => handleOnChange(e.target.value, 'between', 1)}
          value={getValue('between', 1)}
        />
      </InputGroup>
      {column.filterOnSubmit && (
        <div style={{ marginTop: 12, textAlign: 'right' }}>
          <Button
            size='small'
            type='primary'
            disabled={!column.filterValue && !column.finalFilterValue}
            onClick={() => {
              handleFilter(column, 'numerical')
            }}
          >
            {t('lblApply', 'Apply')}
          </Button>
        </div>
      )}
    </div>
  )

  return (
    <Popover placement='bottom' content={content} trigger='click' title={renderResetBtn(column, handleFilter)}>
      <Button size='small' style={{ width: '100%' }}>
        {column.filterValue ? <FontAwesomeIcon icon={faFilter} style={{ color: "#1890ff" }} /> : <FontAwesomeIcon icon={faFilter} />}
      </Button>
    </Popover>
  )
}

const renderResetBtn = (column, handleFilter) => {
  return (
    <Button
      size='small'
      disabled={!column.filterValue}
      onClick={() => {
        column.filterValue = ''
        handleFilter(column, '')
      }}
    >
      {t('lblReset', 'Reset')}
    </Button>
  )
}

function FilteringMethod(value, query) {
  if (value !== undefined && value !== null) {
    const filterVal = query.value
    const filterType = query.type

    switch (filterType) {
      case 'includes': {
        const parsedValue = value
          .toString()
          .trim()
          .toLowerCase()
        const parsedQuery = filterVal
          .toString()
          .trim()
          .toLowerCase()

        if (parsedValue.includes(parsedQuery)) {
          return true
        }

        return false
      }
      case 'greaterThan':
        return Number(value) > Number(filterVal)
      case 'lessThan':
        return Number(value) < Number(filterVal)
      case 'between':
        return Number(value) >= Number(filterVal[0]) && Number(value) <= Number(filterVal[1])
    }
  }

  return false
}

export { NumericalFilter, FilteringMethod }
